import type { WbsClient } from '@bldsoft/cappie/api/wbs'
import type { API } from '@setplex/tria-api'
import type { AdapterDefaults } from '../../index.h'

import { payload } from '@bldsoft/cappie/rest'
import { translationsFromNoraFormat } from './i18n.format'

export function use(
  client: WbsClient,
  i18n: API['i18n'],
  _api: API,
  _defaults: AdapterDefaults
): void {
  //GET /v3/i18n
  // caching, and the conditional request behind it, is the cache rule's job
  i18n.getAllFx.use(async () => {
    const slice = await payload(client.get.api.v3.i18n())
    return translationsFromNoraFormat(slice.content)
  })
}
